// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Epilogue', 'Epilogue Fallback'","fontStyle":"normal"},"className":"__className_09adf1","variable":"__variable_09adf1"};